import React from 'react';
import {
  customerSearchColumns,
  ngoaiTeSearchColumns,
  nhomColumns,
  QUERY_KEYS,
  taiKhoanSearchColumns
} from '@/constants';
import {
  DateRangeDropdownV2,
  FormFieldV2,
  SearchFieldV2 as SearchField,
  UnitDropdownV2
} from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface Props {
  formMode: 'add' | 'edit' | 'view';
}

const BasicInfoTab = ({ formMode }: Props) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Ngày từ/đến</Label>
        <DateRangeDropdownV2
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          fromFieldClassName='w-48'
          toFieldClassName='w-48'
        />
      </div>
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Ngoại tệ</Label>
        <div className='flex-1'>
          <SearchField
            searchColumns={ngoaiTeSearchColumns}
            searchEndpoint={`/${QUERY_KEYS.NGOAI_TE}/`}
            columnDisplay='ma_nt'
            displayRelatedField='ten_nt'
            className='w-fit'
            dialogTitle='Danh mục ngoại tệ'
          />
        </div>
      </div>
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Tài khoản</Label>
        <div className='flex-1'>
          <SearchField
            searchColumns={taiKhoanSearchColumns}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            columnDisplay='code'
            displayRelatedField='name'
            className='w-fit'
            dialogTitle='Danh mục tài khoản'
          />
        </div>
      </div>
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Mã khách hàng</Label>
        <div className='flex-1'>
          <SearchField
            searchColumns={customerSearchColumns}
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            className='w-fit'
            dialogTitle='Danh mục khách hàng'
            disabled={formMode === 'view'}
          />
        </div>
      </div>
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Nhóm khách hàng</Label>
        <div className='flex flex-1 gap-x-2'>
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC1`}
            searchColumns={nhomColumns}
            columnDisplay={'ma_nhom'}
            className='w-fit'
            dialogTitle='Danh mục nhóm'
          />
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC2`}
            searchColumns={nhomColumns}
            columnDisplay={'ma_nhom'}
            className='w-fit'
            dialogTitle='Danh mục nhóm'
          />
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC3`}
            searchColumns={nhomColumns}
            columnDisplay={'ma_nhom'}
            className='w-fit'
            dialogTitle='Danh mục nhóm'
          />
        </div>
      </div>
      <UnitDropdownV2
        formMode={formMode}
        className='flex items-center gap-x-4'
        labelClassName='text-sm font-normal min-w-[150px]'
      />
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Loại chứng từ</Label>
        <FormFieldV2
          type='select'
          name='loai_chung_tu'
          disabled={formMode === 'view'}
          options={[
            { value: 0, label: 'Tất cả' },
            { value: 1, label: 'Chưa phân bổ hết' },
            { value: 2, label: 'Đã phân bổ hết' }
          ]}
          className='w-full'
        />
      </div>
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Xử lý</Label>
        <FormFieldV2
          type='select'
          name='xu_ly'
          disabled={formMode === 'view'}
          options={[
            { value: 0, label: 'Người dùng tự phân bổ' },
            { value: 1, label: 'Gợi ý tự động theo ngày hóa đơn, số hóa đơn' },
            { value: 2, label: 'Gợi ý tự động theo hạn thanh toán, số hóa đơn' }
          ]}
        />
      </div>
    </div>
  );
};

export default BasicInfoTab;
